export default __webpack_public_path__ + "static/FY23_Disclosures-eed4f5f8b48a44a82432d386fad9b8bd.pdf";